<template>
	<td
		:class="{ 'observacao-cell': cellkey === 'Observacao' }"
		@click="handleClick"
	>
		<div>
			<div :style="{ display: showInput ? 'none' : 'block' }">
				<slot />
			</div>
			<input
				ref="inputElement"
				v-model="cellvalueAux"
				type="text"
				style="min-width: 150px"
				:style="{ display: showInput ? 'block' : 'none' }"
				@blur="handleBlur"
			/>
		</div>
	</td>
</template>

<script setup>
import { toValue } from '@vueuse/core'
import { computed, ref, toRefs } from 'vue'
const props = defineProps({
	cellvalue: {
		type: [String, Number],
	},
	cellkey: {
		type: String,
	},
	id: {
		type: String,
	},
})

const { cellvalue } = toRefs(props)

const inputElement = ref()
const inputValue = ref(toValue(cellvalue))
const showInput = ref(false)

const cellvalueAux = computed({
	get() {
		return cellvalue.value
	},
	set(v) {
		inputValue.value = v
	},
})

const emit = defineEmits(['changed'])

const handleClick = () => {
	showInput.value = true
	setTimeout(() => {
		inputElement.value.focus()
	}, 200)
}

const handleBlur = () => {
	showInput.value = false
	if (inputValue.value != cellvalue.value) {
		emit('changed', { key: props.cellkey, value: inputValue.value || undefined, id: props.id })
	}
}
</script>

<style scoped>
td {
	padding: 0.5rem;
	font-size: 0.8rem;
	border: 0.5px solid #ccc;
	white-space: nowrap;
	min-width: 170px;
}

.observacao-cell {
	white-space: pre-wrap !important;
	word-break: break-word !important;
	width: 170px !important;
	min-width: 170px !important;
}
</style>
